module.exports = __webpack_public_path__ + "static/media/FilterIconBlack.d97893c4.svg";